module.exports = __webpack_public_path__ + "img/monitor-refresh.69918132.png";